/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Vishal Goel’ <vishal@wakencode.com>, February 2020
 *
 *****************************************************************************/

import axios from "axios";

// All urls corresponding axios instances created here

const serviceActivatorBaseUrl = process.env.REACT_APP_API_URL;

const axiosSA = axios.create({
  baseURL: serviceActivatorBaseUrl,
});

export { axiosSA };
